import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatAutocompleteModule, MatInputModule, MatProgressBarModule } from "@angular/material";
import { HotTableModule } from "@handsontable/angular";
import { TranslateModule } from "@ngx-translate/core";
import { NgZorroAntdModule } from "ng-zorro-antd";
import { NgxExtendedPdfViewerModule } from "ngx-extended-pdf-viewer";
import { NgxMaskModule } from "ngx-mask";
import { SlickCarouselModule } from "ngx-slick-carousel";
import { MaterialModule } from "src/app/core/material";
import { NgMatAutocompleteModule } from "src/app/shared/components/autocomplete/autocomplete.module";
import { SharedModule } from "src/app/shared/shared.module";
import { NotifyModule } from "../notify/notify.module";
import { ContractLotStandardizedRoutingModule } from "./contract-lot-standardized-routing.module";
import { ContractLotStandardizedComponent } from "./contract-lot-standardized/contract-lot-standardized.component";

@NgModule({
  declarations: [
    ContractLotStandardizedComponent,
  ],
  imports: [
    CommonModule,
    ContractLotStandardizedRoutingModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    TranslateModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgMatAutocompleteModule,
    MatInputModule,
    NgxMaskModule.forChild(),
    NgxExtendedPdfViewerModule,
    NgZorroAntdModule,
    SlickCarouselModule,
    NotifyModule,
    HotTableModule,
  ],
  exports: [],
  entryComponents: [
    ContractLotStandardizedComponent,
  ],
})
export class ContractLotStandardizedModule {}
